import DOMPurify from 'dompurify';

export const isIE9OrOlder = function() {
  return window.document.documentMode ? true : false;
};

export const truncate = function(string, length, ellipsis) {
  ellipsis = ellipsis || '...';
  length = ~~length;

  return string.length > length ? string.slice(0, length) + ellipsis : string;
};

export const sanitize = function(string, options = {}) {
  return DOMPurify.sanitize(string, {
    ...{ USE_PROFILES: { html: true }},
    ...options
  });
};

export const route = function(uri, variables = {}) {
  return '/' + uri.replace(new RegExp('\{([^\{]+)\}', 'g'), (_, name) => {
    return variables[name];
  });
};

export const validSubdomainString = function (text) {
  return text
      .toLowerCase()
      .trim()
      .replace(/grants|awards|grant|award/g, '')
      .replace(/\s+/g, '')
      .replace(/[^\p{L}]+/ug, '');
};
